import { getAgents } from "./get.groupOwner.agent";

export const agent = {
	getAgents
};
